import { render, staticRenderFns } from "./d3TextLayerDrawer.vue?vue&type=template&id=020d1c77&"
import script from "./d3TextLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./d3TextLayerDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports